import { formatFullName } from './formatFullName';
import type { AccountDeletionSummary, AccountLifecycleStatus } from '@/shared/model/types/accountDeletion';

export const isDeletedAccount = (status?: AccountLifecycleStatus | null): boolean => status === 'deleted';

export const isPendingDeletion = (status?: AccountLifecycleStatus | null): boolean => status === 'pending_deletion';

export const canRestoreAccount = (
  status?: AccountLifecycleStatus | null,
  deletion?: AccountDeletionSummary | null,
): boolean => {
  if (!isPendingDeletion(status)) return false;

  return deletion?.scheduledDeletionAt
    ? new Date(deletion.scheduledDeletionAt).getTime() > Date.now()
    : Number(deletion?.remainingDays) > 0;
};

export const isActiveAccount = (status?: AccountLifecycleStatus | null): boolean => status === 'active';

export const getAccountDisplayName = (item: {
  id: number;
  accountStatus?: AccountLifecycleStatus | null;
  name?: string | null;
  nickname?: string | null;
  lastName?: string | null;
  firstName?: string | null;
  patronymic?: string | null;
}): string => {
  if (isDeletedAccount(item.accountStatus)) {
    return `Удалённый аккаунт #${item.id}`;
  }

  return (
    formatFullName(item.lastName, item.firstName, item.patronymic) ||
    (typeof item.nickname === 'string' ? item.nickname.trim() : '') ||
    (typeof item.name === 'string' ? item.name.trim() : '') ||
    '—'
  );
};

export const getClubDisplayName = (item: {
  id: number;
  accountStatus?: AccountLifecycleStatus | null;
  name?: string | null;
}): string => {
  if (isDeletedAccount(item.accountStatus)) {
    return `Удалённый клуб #${item.id}`;
  }

  return typeof item.name === 'string' && item.name.trim() ? item.name.trim() : '—';
};

export const hasNonActiveSelection = (statuses?: Array<AccountLifecycleStatus | null | undefined>): boolean =>
  Boolean(statuses?.some((status) => status !== undefined && status !== 'active'));
